
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blog-posts/curify-your-core-curriculum",
      function () {
        return require("private-next-pages/c/blog-posts/curify-your-core-curriculum.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blog-posts/curify-your-core-curriculum"])
      });
    }
  